import * as React from "react";
import {
  useDispatch,
  useMappedState
} from "redux-react-hook";

import { setCurrentList } from "src/core/lists/store/lists.actions";
import {
  setCurrentOrder,
  setCurrentOrderMode
} from "src/core/orders/store/orders.actions";
import { IStore } from "src/core/shared/store/index";

import { ICurrentOrder } from "../api/orders.api";

const useSetCurrentOrder = () => {
  const dispatch = useDispatch();
  const currentList = useMappedState(({ lists }: IStore) => lists.currentList);

  return React.useCallback(
    (newCurrentOrder: ICurrentOrder | null) => {
      if (currentList.data && newCurrentOrder) {
        dispatch(setCurrentList(null));
      }

      dispatch(setCurrentOrder(newCurrentOrder || null));
    },
    [ currentList ]
  );
};

export const useSetCurrentOrderMode = () => {
  const dispatch = useDispatch();
  const currentList = useMappedState(({ lists }: IStore) => lists.currentList);

  return React.useCallback(
    (newCurrentOrderMode: ICurrentOrder["mode"]) => {
      if (currentList.data && newCurrentOrderMode) {
        dispatch(setCurrentList(null));
      }

      dispatch(setCurrentOrderMode(newCurrentOrderMode || null));
    },
    [ currentList.data, dispatch ]
  );
};

export default useSetCurrentOrder;
